import { supabase } from './supabase';

// Preferencias del usuario guardadas en el servidor (cada cuenta tiene las suyas).
export const loadPrefs = async (userId) => {
  const { data, error } = await supabase.from('user_prefs').select('prefs').eq('user_id', userId).maybeSingle();
  if (error) throw error;
  return data?.prefs || {};
};

export const savePrefs = async (userId, patch) => {
  const cur = await loadPrefs(userId).catch(() => ({}));
  const { error } = await supabase.from('user_prefs')
    .upsert({ user_id: userId, prefs: { ...cur, ...patch }, updated_at: new Date().toISOString() }, { onConflict: 'user_id' });
  if (error) throw error;
};
